export const m_server = $("#url_api").val();
export const m_app = $("#url_app").val();